import { extendTailwindMerge } from 'tailwind-merge'

/** The steps `styles.css` declares for the package's own scales. */
const TEXT = ['aria-xxs', 'aria-xs', 'aria-sm', 'aria-base', 'aria-lg', 'aria-xl', 'aria-2xl', 'aria-3xl']
const RADIUS = ['aria-xs', 'aria-sm', 'aria-md', 'aria-lg']
const SHADOW = ['aria-sm', 'aria-lg', 'button', 'input']

/**
 * Merges Tailwind classes, letting a later class win over an earlier one.
 *
 * Internal to the package. Components do not accept a `className` from callers,
 * so this exists to compose variants inside a component, not to let a consumer
 * reach in and restyle it.
 *
 * The merge has to be taught this package's own scales. tailwind-merge only
 * knows the stock ones, so it reads `text-aria-base` as a colour and drops the
 * real colour beside it: a menu item rendered with no size at all, because
 * `text-foreground` looked like a conflicting class in the same group. A custom
 * scale the merge does not know about is worse than no merge at all, because it
 * fails silently and only on the classes the design system added.
 *
 * Anything added to `styles.css` outside a stock Tailwind scale belongs here
 * too. `packages/ui/src/__tests__/tokens.test.ts` fails if the two disagree.
 */
export const cn = extendTailwindMerge({
    extend: {
        classGroups: {
            // --text-xxs, plus the package's own --text-aria-* scale.
            'font-size': [{ text: ['xxs', ...TEXT] }],
            rounded: [{ rounded: RADIUS }],
            shadow: [{ shadow: SHADOW }]
        }
    }
})
